import { useNavigation } from 'react-router';

/** 2 px brass bar at the very top while the router is loading a route (lazy chunk, loader, submit). */
export function RouteProgress() {
  const navigation = useNavigation();
  if (navigation.state === 'idle') return null;
  return <div className="route-progress" aria-hidden="true" />;
}
